import {AbstractApp} from "../app";
import {AbstractPreferencesManager} from "./AbstractPreferencesManager";

export class LocaleManager extends AbstractPreferencesManager {

    static readonly en = 'en'; // English
    static readonly es = 'es'; // Spanish
    static readonly fr = 'fr'; // French
    static readonly de = 'de'; // German
    static readonly ru = 'ru'; // Russian
    static readonly uk = 'uk'; // Ukrainian
    static readonly pl = 'pl'; // Польский
    static readonly pt = 'pt'; // Португальский
    // readonly hi = 'hi'; // Hindi

     readonly languagesNames = {
        [LocaleManager.en]: 'English',
        [LocaleManager.es]: 'Español',
        [LocaleManager.fr]: 'Français',
        [LocaleManager.de]: 'Deutsch',
        [LocaleManager.ru]: 'Русский',
        [LocaleManager.uk]: 'Українська',
        [LocaleManager.pl]: 'Polski',
        [LocaleManager.pt]: 'Português'
        // [Locale.hi]: हिन्दी (Hindi, Хинди)
    };

    readonly app: AbstractApp;
    readonly needPersistence:boolean;
    readonly supportedLanguages:string[];

    protected static LANG_CODE_KEY = 'LANG_CODE_KEY';
    protected _currentLangCode!:string;

    constructor(app: AbstractApp, needPersistence: boolean, supportedLanguages:string[]) {
        super();
        this.app = app;
        this.needPersistence = needPersistence;
        this.supportedLanguages = supportedLanguages;
    }

    async init() {
        if (this.needPersistence) {
            this._currentLangCode = await this.getValue(LocaleManager.LANG_CODE_KEY) || '';
        }

        if (!this._currentLangCode) {
            let deviceLanguageCode = this.app.device.deviceLanguageCode;
            if (this.supportedLanguages.includes(deviceLanguageCode)) {
                this._currentLangCode = deviceLanguageCode;
            } else {
                this._currentLangCode = LocaleManager.en;
            }

            if (this.needPersistence) {
                await this.setValue(LocaleManager.LANG_CODE_KEY, this._currentLangCode);
            }
        }
    }

    getText(localeObject:Record<string, string>, innerTxt:string | null = null, innerTxt2:string | null = null):string {
        // @ts-ignore
        let text = localeObject[this._currentLangCode] || localeObject[this.en] || '';
        if (innerTxt != null) {
            text = text.split("[x]").join(innerTxt);
        }
        if (innerTxt2 != null) {
            text = text.split("[y]").join(innerTxt2);
        }
        return text;
    }

    getLang(): string {
        return this._currentLangCode;
    }

    async setLang(value: string) {
        if(this._currentLangCode != value && this.supportedLanguages.includes(value)) {
            this._currentLangCode = value;
            if (this.needPersistence) {
                await this.setValue(LocaleManager.LANG_CODE_KEY, value);
            }
        }
    }
}